import React from 'react';
import { useLocation } from 'react-router-dom';

const ResultConfirm: React.FC = () => {
  // useLocation 훅을 사용하여 쿼리 파라미터를 가져옴
  const location = useLocation();

  // URLSearchParams를 사용해 쿼리 파라미터를 파싱
  const queryParams = new URLSearchParams(location.search);

  // 쿼리 파라미터 값들을 객체 형태로 변환
  const queryObj: Record<string, string> = {};
  queryParams.forEach((value, key) => {
    queryObj[key] = value;
  });

  return (
    <div>
      <h1>Query Parameters</h1>
      <pre>{JSON.stringify(queryObj, null, 2)}</pre>
    </div>
  );
};

export default ResultConfirm;
